module.exports = function getResource(label, vars = []) {
    let resources = {
        infoPublicProfile: 'This info is not shown on your public profile'
    };
    return resources[label];
};
